import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, DatePicker, Form, Input, message, Radio, Row, Space, Upload, Select } from 'antd';
import dayjs from 'dayjs';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';

import { fetchPackingModeList, resetPackingModeData } from '../../../slices/packing';
import { fetchAlloysList, resetAlloyList, resetCurrentAlloyListPage } from '../../../slices/alloy';
import { fetchCustomerList, resetCurrentCustomerPage, resetCustomerList } from '../../../slices/customer';
import { fetchTempersList, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
import { fetchDieProfileById, fetchDieProfileList, resetCurrentDieProfilePage, resetDieProfileList } from './../../../slices/die-profile';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
import { fetchSalesOrderById } from '../../../slices/sales-order';
import moment from 'moment';
import { fetchNalcoRateForQuotation } from '../../../slices/nalco-rate';
import { createNumberValidationRule } from '../../../utils/CreateNumberValidationRule';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';

const { Option } = Select;

function ConvertSalesToWorkOrder() {
  const [searchDieProfile, setSearchDieProfile] = useState('');
  const [sameCustomer, setSameCustomer] = useState(false);
  const [currentWTKg, setCurrentWTKg] = useState('');
  const [poCopyList, setPoCopyList] = useState([]);
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const inputRef = useRef(null);
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const { id } = useParams();
  const [searchAlloy, setSearchAlloy] = useState('');
  const [selectedOption, setSelectedOption] = useState({});
  const [searchTemper, setSearchTemper] = useState('');
  let navigate = useNavigate();
  const [searchCustomer, setSearchCustomer] = useState('');
  const [initialValues, setInitialValues] = useState({});
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [quotationNumber, setQuotationNumber] = useState(null);
  const { list: customerList } = useSelector(state => state.customer);
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);
  const { list: dieProfileList, loading: dieProfileLoading, currentPage: dieProfileCurrentPage, hasMore: dieProfileHasMore } = useSelector(state => state.dieProfile);

  const { list: alloyList, loading: alloyLoading, currentPage: alloyCurrentPage, hasMore: alloyHasMore } = useSelector(state => state.alloy);
  const { list: temperList, loading: temperLoading, hasMore: temperHasMore } = useSelector(state => state.temper);

  useEffect(() => {
    const fetchSalesOrder = async () => {
      try {
        const response = await dispatch(fetchSalesOrderById(id)).unwrap();
        
        if (response?.data) {
          form.setFieldsValue({
            bill_to: response.customer?.id || null,
            tolerance: '+-10%',
            purchase_order_no: response?.data?.purchase_order_number,
            purchase_order_date: response?.data?.purchase_order_date ? dayjs(response.data.purchase_order_date) : null,
            project_name: response.project_name,
            remarks: response?.data?.remarks,
            workorder_type: 'In House',
            packing_type: response?.data?.packing_mode,
            work_order_details: response?.data?.inquiry_salesorder_details?.length > 0 ? response.data.inquiry_salesorder_details?.map(detail => ({
              id: detail ? detail.id : null,
              //die_profile: detail.die_profile ? { label: detail.die_profile.die_number, value: detail.die_profile.id } : undefined,
              customer_reference_number: detail?.section_no || '',
              conversion: detail?.conversion || '',
              packing_cost: detail?.packing_cost,
              alloy: detail?.alloy,
              temper: detail.temper,
              length: detail?.length || null,
              nalco_rate: detail?.price_per_kg || '',
              nalco_rate_change_reason: detail?.nalco_rate_change_reason || null,
              modify_nalco_rate: detail?.modify_nalco_rate,
              unit_of_measurement: detail?.unit_of_measurement || '',
              description: detail?.description || '',
              surface_finish: detail?.surface_finish || '',
              net_weight: detail?.quantity || null,
              min_weight: detail?.min_weight || null,
              max_weight: detail?.max_weight || null,
              pieces: detail?.pieces || null,
              wt_kg_p_mt: detail?.die_profile?.wt_kg_p_mt || null, // Convert to number
              jobwork: detail?.surface_finish || [],
              cutting: detail?.cutting || false,
              machinings: detail.machinings || false,
              deburring: detail.deburring || false,
              cutting_price: detail.cutting_price || undefined,
              machinings_price: detail.machinings_price || undefined,
              deburring_price: detail.deburring_price || undefined,
              anodising: detail.anodising || false,
              powder_coating: detail.powder_coating || false,
              pvdf: detail.pvdf || false,
              anodising_description: detail.anodising_description || undefined,
              anodising_price: detail.anodising_price || undefined,
              powder_coating_description: detail.powder_coating_description || undefined,
              powder_coating_price: detail.powder_coating_price || undefined,
              pvdf_description: detail.pvdf_description || undefined,
              pvdf_price: detail.pvdf_price || undefined,
              laser_marking_description: detail.laser_marking_description || undefined,
              laser_marking_price: detail.laser_marking_price || undefined,
            }))
              : [
                {
                  die_profile: undefined,
                  customer_reference_no: '',
                  alloy: null,
                  temper: undefined,
                  length: null,
                  conversion: '',
                  price_per_kg: '',
                  unit_of_measurement: '',
                  description: '',
                  surface_treatment: '',
                  surface_finish: '',
                  net_weight: null,
                  pieces: null,
                  jobwork: [],
                  cutting: false,
                  machinings: false,
                  deburring: false,
                  cutting_price: undefined,
                  machinings_price: undefined,
                  deburring_price: undefined,
                  anodising: false,
                  powder_coating: false,
                  pvdf: false,
                  anodising_description: undefined,
                  anodising_price: undefined,
                  powder_coating_description: undefined,
                  powder_coating_price: undefined,
                  pvdf_description: undefined,
                  pvdf_price: undefined,
                  laser_marking_description: undefined,
                  laser_marking_price: undefined,
                },
              ],
          });
          handleToleranceChange('+-10%');
          setQuotationNumber(response?.quotation_no);
          const sourceFiles = response?.data?.purchase_order_copy
            ? [
              {
                uid: '-1', // Use a negative number for existing files
                name: response?.data?.purchase_order_copy.split('/').pop(),
                url: response?.data?.purchase_order_copy,
                status: 'done',
                thumbUrl: response?.data?.purchase_order_copy,
              },
            ]
            : [];
          setPoCopyList(sourceFiles);
          form.setFieldsValue({ purchase_order_copy: sourceFiles });

        }
      } catch (error) {
        console.error('Error fetching quotation:', error);
      }
    };

    fetchSalesOrder();
  }, [id, form, dispatch, fetchSalesOrderById]);


  useEffect(() => {
    const orderDate = dayjs();
    const deliveryDate = orderDate.clone().add(12, 'days');
    form.setFieldsValue({
      order_date: orderDate,
      delivery_date: deliveryDate,
    });
  }, [form]);

  const disablePastDates = current => {
    const currentOrderDate = form.getFieldValue('order_date') || moment();
    return (
      current &&
      current <
      moment.max(moment().startOf('day').add(1, 'days'), currentOrderDate)
    );
  };

  useEffect(() => {
    dispatch(resetPackingModeData());
    dispatch(resetJobWorkList());
    dispatch(resetDieProfileList());
    dispatch(resetCurrentCustomerPage());
    dispatch(resetCurrentAlloyListPage());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetCustomerList());
    dispatch(resetAlloyList());
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(fetchjobWorkList());
    dispatch(
      fetchCustomerList({
        page: 1, pagesize: 1000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
      dispatch(
        fetchAlloysList({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
      dispatch(
        fetchTempersList({
          page: 1,
          pagesize: 1000,
          ...(search && { search: search }),
          ...(orderBy && { ordering: orderBy }),
        }),
      ),
    );
    dispatch(
      fetchDieProfileList({
        page: 1,
        pagesize: 5000,
        ...(search && { search: search }),
        ...(orderBy && { ordering: orderBy }),
      }),
    );

  }, [dispatch, page, pagesize, search, orderBy]);


  const onScrollDieProfile = async event => {
    const target = event.target;
    if (!dieProfileLoading && dieProfileHasMore && target.scrollTop + target.offsetHeight === target.scrollHeight) {
      dispatch(
        fetchDieProfileList({ page: dieProfileCurrentPage, pagesize: 5000 }),
      );
    }
  };

  const handleSearchDieProfile = e => {
    const value = e.target.value;
    if (value) {
      setSearchDieProfile(value);
      dispatch(fetchDieProfileList({ page: 1, pagesize: 5000, search: value }));
    } else {
      setSearchDieProfile('');
      dispatch(fetchDieProfileList({ page: 1, pagesize: 5000 }));
    }
  };

  const handleAlloy = (selected, option, index) => {
    const updatedDetails = form
      .getFieldValue('work_order_details')
      .map((item, i) => (i === index ? { ...item, alloy: selected } : item));

    form.setFieldsValue({ work_order_details: updatedDetails });
  };

  const handleSearchAlloy = value => {
    setSearchAlloy(value);

    if (value) {
      setSearchAlloy(value);
      dispatch(resetAlloyList());
      dispatch(fetchAlloysList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchAlloy('');
      dispatch(resetAlloyList());
      dispatch(resetCurrentAlloyListPage());
      dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
    }
  };

  const onScrollAlloy = async event => {
    const target = event.target;
    if (
      !alloyLoading &&
      alloyHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchAlloysList({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };


  const handleSearchTemer = value => {
    setSearchTemper(value);
    if (value) {
      setSearchTemper(value);
      dispatch(resetTempersList());
      dispatch(fetchTempersList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchTemper('');
      dispatch(resetTempersList());
      dispatch(resetCurrentTemperPage());
      dispatch(fetchTempersList({ page: 1, pagesize: 1000 }));
    }
  };

  const handleBillToChange = value => {
    form.setFieldValue('bill_to', value); // Update field value
    form.validateFields(['bill_to']); // Trigger validation
    handleChangeCustomer(value);
    if (value === form.getFieldValue('ship_to')) {
      setSameCustomer(true);
    } else {
      setSameCustomer(false);
    }
  };
  const handleShipToChange = value => {
    form.setFieldValue('ship_to', value); // Update field value
    form.validateFields(['ship_to']); // Trigger validation
    handleChangeCustomer(value);
    if (value === form.getFieldValue('bill_to')) {
      setSameCustomer(true);
    } else {
      setSameCustomer(false);
    }
  };
  const onScrollTemper = async event => {
    const target = event.target;
    if (
      !temperLoading &&
      temperHasMore &&
      target.scrollTop + target.offsetHeight === target.scrollHeight
    ) {
      dispatch(fetchTempersList({ page: alloyCurrentPage, pagesize: 1000 }));
    }
  };



  const handleSearchCustomer = value => {
    setSearchCustomer(value);
    if (value) {
      setSearchCustomer(value);
      dispatch(fetchCustomerList({ page: 1, pagesize: 1000, search: value }));
    } else {
      setSearchCustomer('');
      dispatch(fetchCustomerList({ page: 1, pagesize: 1000 }));
    }
  };
  const handleChangeCustomer = value => {
    setSearchCustomer(value);
  };

  const handleprofile = async (value, index) => {
    const updatedQuotationDetails = [
      ...form.getFieldValue('work_order_details'),
    ];
    updatedQuotationDetails[index] = {
      ...updatedQuotationDetails[index],
      die_profile: value?.value,
    };
    form.setFieldsValue({
      work_order_details: updatedQuotationDetails,
    });
    setSelectedIndex(index); // Track which row is being updated
    try {
      const response = await dispatch(
        fetchDieProfileById(value?.value),
      ).unwrap();

      if (response?.results?.data?.length > 0) {
        const customerRefNo =
          response.results.data[0]?.customer_reference_number || '';
        const currentWTKg = response.results.data[0]?.wt_kg_p_mt || '';
        setCurrentWTKg(currentWTKg);
        updatedQuotationDetails[index] = {
          ...updatedQuotationDetails[index],
          customer_reference_number: customerRefNo,
          wt_kg_p_mt: currentWTKg,
        };
        form.setFieldsValue({
          work_order_details: updatedQuotationDetails,
        });
      } else {
        console.warn('No data found for the selected die profile.');
      }
    } catch (error) {
      console.error('Error fetching customer reference number:', error);
    }
  };

  useEffect(() => {
    if (selectedIndex === null) return; // Skip if no index is selected
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const updatedDetails = [...workOrderDetails];
    const item = updatedDetails[selectedIndex];

    if (item) {
      const currentKg = currentWTKg || 0;
      const length = parseFloat(item.length) || 0;
      const pieces = parseFloat(item.pieces) || 0;
      const netWeight = ((currentKg * length) / 1000) * pieces;
      const toleranceValue = form.getFieldValue('tolerance') || '';
      const tolerancePercent = toleranceValue
        ? parseFloat(toleranceValue.replace(/[^\d.]/g, '')) || 0
        : 0;
      const isPositive = toleranceValue.includes('+');
      const isNegative = toleranceValue.includes('-');
      let max_weight = netWeight;
      let min_weight = netWeight;

      if (tolerancePercent > 0) {
        if (isPositive && isNegative) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight * (1 - tolerancePercent / 100);
        } else if (isPositive) {
          max_weight = netWeight * (1 + tolerancePercent / 100);
          min_weight = netWeight; // Fix: Keep it same
        } else if (isNegative) {
          min_weight = netWeight * (1 - tolerancePercent / 100);
          max_weight = netWeight; // Fix: Keep it same
        }
      }
      updatedDetails[selectedIndex] = {
        ...item,
        net_weight: netWeight.toFixed(3),
        max_weight: max_weight.toFixed(3),
        min_weight: min_weight.toFixed(3),
      };
      form.setFieldsValue({
        work_order_details: updatedDetails,
      });
    }
  }, [currentWTKg, selectedIndex, form]); // Runs only when selectedIndex or currentWTKg changes



  const handleTemer = (selected, option, index) => {
    const updatedDetails = form
      .getFieldValue('work_order_details')
      .map((item, i) => (i === index ? { ...item, temper: selected } : item));

    form.setFieldsValue({ work_order_details: updatedDetails });
  };
  const [btnLoading, setBtnLoading] = useState(false);
  const handlePoCopyChange = (info) => {
    const newFileList = info.fileList.slice(-1).map(file => ({
      uid: file.uid,
      name: file.name,
      status: file.status,
      url: file.url || (file.originFileObj && URL.createObjectURL(file.originFileObj)),
      originFileObj: file.originFileObj,
    }));

    setPoCopyList(newFileList);
    // keep Form in sync
    form.setFieldsValue({ purchase_order_copy: newFileList });
  };

  // onRemove handler
  const handlePoCopyRemove = (file) => {
    // remove file from state
    const newList = poCopyList.filter(f => f.uid !== file.uid);
    setPoCopyList(newList);
    // update form field too
    form.setFieldsValue({ purchase_order_copy: newList });
    // return true to allow Upload to remove it
    return true;
  };

  const handleFinish = values => {
    setBtnLoading(true); // Set loading state to true
    const formattedOrderDate = dayjs(values.order_date).format('YYYY-MM-DD');
    const formattedDeliveryDate = dayjs(values.delivery_date).format(
      'YYYY-MM-DD',
    );
    const formattedPurchaseOrderDate = dayjs(values.purchase_order_date).format(
      'YYYY-MM-DD',
    );

    const payload = {
      quotation_no: quotationNumber,
      bill_to: values.bill_to,
      ship_to: values.ship_to,
      order_date: formattedOrderDate,
      delivery_date: formattedDeliveryDate,
      purchase_order_no: values.purchase_order_no,
      purchase_order_date: formattedPurchaseOrderDate,
      packing_type: values.packing_type,
      project_name: values.project_name,
      nalco_rate: values.nalco_rate,
      workorder_type: values.workorder_type,
      tolerance: values.tolerance,
      status: values.status,
      order_no: values.order_no,
      work_order_details: values.work_order_details.map(detail => {
        const formattedDetail = {
          die_profile: detail?.die_profile?.value
            ? detail?.die_profile?.value
            : detail?.die_profile,
          description: detail?.description ? detail?.description : '',
          alloy: detail.alloy
            ? typeof detail.alloy === 'object'
              ? detail.alloy.value
              : detail.alloy
            : null,
          temper: detail.temper
            ? typeof detail.temper === 'object'
              ? detail.temper.value
              : detail.temper
            : null,

          customer_reference_number: detail.customer_reference_number,
          length: parseFloat(detail.length) || null,
          pieces: parseFloat(detail.pieces) || null,
          net_weight: parseFloat(detail.net_weight) || null,
          min_weight: parseFloat(detail.min_weight) || null,
          max_weight: parseFloat(detail.max_weight) || null,
          nalco_rate: parseFloat(detail.nalco_rate) || null,
          nalco_rate_change_reason: detail.nalco_rate_change_reason,
          modify_nalco_rate: detail?.modify_nalco_rate ? detail.modify_nalco_rate : false,
          conversion: parseFloat(detail.conversion) || null,
          finishing_price: parseFloat(detail.finishing_price) || null,
          jobwork: detail?.jobwork,
          cutting: detail?.cutting,
          machinings: detail?.machinings || false,
          deburring: detail?.deburring || false,
          cutting_price: detail?.cutting_price,
          machinings_price: detail?.machinings_price,
          deburring_price: detail?.deburring_price,
          anodising: detail?.anodising || false,
          powder_coating: detail?.powder_coating || false,
          pvdf: detail?.pvdf || false,
          anodising_description: detail?.anodising_description,
          anodising_price: detail?.anodising_price,
          powder_coating_description: detail?.powder_coating_description,
          powder_coating_price: detail?.powder_coating_price,
          pvdf_description: detail?.pvdf_description,
          pvdf_price: detail?.pvdf_price,
          laser_marking_description: detail?.laser_marking_description || undefined,
          laser_marking_price: detail?.laser_marking_price || undefined,
        };

        Object.keys(formattedDetail).forEach(key => {
          if (formattedDetail[key] === null) {
            delete formattedDetail[key];
          }
        });

        return formattedDetail;
      }),
    };
    
    const formData = new FormData();
    formData.append('data', JSON.stringify(payload));
    if (poCopyList.length > 0 && poCopyList[0]?.originFileObj) {
      formData.append('po_copy', poCopyList[0].originFileObj);
    }
    // dispatch(quotationCreateWorkoder({ values: formData }))
    //   .unwrap()
    //   .then(result => {
    //     if (result.success) {
    //       message.success('Quotation Converted Successfully!');
    //       setQuotationNumber(null);
    //       navigate(`/view-quotation-list/${id}`);
    //     }
    //   })
    //   .catch(error => {
    //     let displayMessage = '';
    //     if (typeof error === 'object') {
    //       displayMessage = Object.entries(error)
    //         .map(([key, value]) => `${key}: ${value.join(', ')}`)
    //         .join('\n');
    //       message.error(displayMessage);
    //     } else {
    //       message.error(
    //         `Error: ${error || 'Failed to convert to work order.'}`,
    //       );
    //     }
    //   })
    //   .finally(() => {
    //     setBtnLoading(false); // Reset loading state
    //   });
  };

  const handleSameCustomerCheck = e => {
    const checked = e.target.checked;
    setSameCustomer(checked);

    if (checked) {
      const selectedCustomer = form.getFieldValue('bill_to');
      form.setFieldsValue({
        ship_to: selectedCustomer,
      });
    } else {
      form.setFieldsValue({
        ship_to: null,
      });
    }
  };


  const handleToleranceChange = value => {
    const workOrderDetails = form.getFieldValue('work_order_details') || [];
    const toleranceMatch = value.match(/(\+-|\+|-)?\d+/g);
    const toleranceValue = toleranceMatch
      ? Math.abs(parseFloat(toleranceMatch[0].replace('+-', '')))
      : 0;
    const hasPositive =
      toleranceMatch.some(val => val.includes('+')) && !value.includes('+-');
    const hasNegative =
      toleranceMatch.some(val => val.includes('-')) && !value.includes('+-');
    const hasBoth = value.includes('+-') || value.includes('±');

    const updatedDetails = workOrderDetails.map(item => {
      const netWeight = parseFloat(item.net_weight) || 0;

      let max_weight = netWeight;
      let min_weight = netWeight;

      if (toleranceValue > 0) {
        if (hasBoth) {
          max_weight = netWeight * (1 + toleranceValue / 100);
          min_weight = netWeight * (1 - toleranceValue / 100);
        } else if (hasPositive) {
          max_weight = netWeight * (1 + toleranceValue / 100);
          min_weight = netWeight; // No change for minus
        } else if (hasNegative) {
          min_weight = netWeight * (1 - toleranceValue / 100);
          max_weight = netWeight; // No change for plus
        }
      }

      return {
        ...item,
        net_weight: netWeight.toFixed(3),
        max_weight: max_weight.toFixed(3),
        min_weight: min_weight.toFixed(3),
      };
    });
    form.setFieldsValue({ work_order_details: updatedDetails });
  };

  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Convert Sales Order To Work Order</h2>
          <div className="bredcrumbwrp">
            <Link to="/work-order-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/work-order-list">Work Orders</Link> },
                { title: 'Create Work Order' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form layout="vertical" form={form} onFinish={handleFinish}>
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="bill_to"
                  label="Customer (Bill To)"
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Select
                    placeholder="Please Select Company Name"
                    onChange={value => handleBillToChange(value)}
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch={true}
                    value={searchCustomer}
                    allowClear
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={el.id} value={el.id}>
                        {el.customer_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <label
                  className="customlabel flex"
                  style={{ marginBottom: '3px' }}
                >
                  {' '}
                  Customer (Ship To) -
                  <div className="ml-2">
                    <Checkbox
                      checked={sameCustomer}
                      onChange={handleSameCustomerCheck}
                    >


                      Same as bill to
                    </Checkbox>
                  </div>
                </label>
                <Form.Item
                  name="ship_to"
                  label=""
                  rules={[
                    { required: true, message: 'Please select company name' },
                  ]}
                >
                  <Select
                    placeholder="Please Select Company Name"
                    onChange={value => {
                      handleShipToChange(value);
                    }}
                    onSearch={handleSearchCustomer}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    showSearch={true}
                    value={searchCustomer}
                    allowClear
                  >
                    {[
                      ...new Map(
                        customerList.map(item => [item.id, item]),
                      ).values(),
                    ].map((el, index) => (
                      <Option key={el.id} value={el.id}>
                        {el.customer_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    { required: true, message: 'Please select order date' },
                  ]}
                >
                  <DatePicker style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabled
                    defaultValue={moment()} // Current date as default
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={6} xl={4}>
                <Form.Item
                  name="delivery_date"
                  label="Delivery Date"
                  rules={[
                    { required: true, message: 'Please select delivery date' },
                    () => ({
                      validator(_, value) {
                        const orderDate = form.getFieldValue('order_date');
                        if (
                          !value ||
                          !orderDate ||
                          value.isAfter(orderDate, 'day') ||
                          value.isSame(orderDate, 'day')
                        ) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            'Delivery date must be on or after the order date',
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <DatePicker style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabledDate={disablePastDates}
                  />
                </Form.Item>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4}>
                <Form.Item
                  name="purchase_order_no"
                  label="Purchase Order No"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid purchase order no',
                    },
                  ]}
                >
                  <Input placeholder="Enter Purchase Order No" />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_date"
                  label="Purchase Order Date"
                  rules={[
                    {
                      required: true,
                      message: 'Please select purchase order date',
                    },
                  ]}
                >
                  <DatePicker
                    format="DD-MM-YYYY"
                    style={{ width: '100%' }}
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="packing_type"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select packing mode' },
                  ]}
                >
                  <Select
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                  />
                </Form.Item>

              </Col>
              <Col xs={24} sm={12} xl={8} xxl={6}>
                <Form.Item
                  name="project_name"
                  label="Project Name"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid project name',
                    },
                  ]}
                >
                  <Input
                    placeholder="Enter Project Name"
                    onChange={e => {
                      const value = e.target.value;
                      const formattedValue = value
                        .toLowerCase()
                        .replace(/\b\w/g, char => char.toUpperCase());
                      form.setFieldsValue({ project_name: formattedValue }); // Update Form state
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="tolerance"
                  label="Tolerance"
                  rules={[
                    {
                      required: true,
                      message: 'Please select a tolerance value',
                    },
                  ]}
                >
                  <Select
                    placeholder="Select Tolerance"
                    onChange={handleToleranceChange}
                  >
                    <Option value="Zero(0)">Zero(0)</Option>
                    <Option value="+-3%" style={{ letterSpacing: '2px' }}>
                      ±3%
                    </Option>
                    <Option value="+-5%">±5%</Option>
                    <Option value="+-7%">±7%</Option>
                    <Option value="+-10%">±10%</Option>
                    <Option value="+3%">+3%</Option>
                    <Option value="+5%">+5%</Option>
                    <Option value="+7%">+7%</Option>
                    <Option value="+10%">+10%</Option>
                    <Option value="-3%">-3%</Option>
                    <Option value="-5%">-5%</Option>
                    <Option value="-7%">-7%</Option>
                    <Option value="-10%">-10%</Option>
                  </Select>
                </Form.Item>
              </Col>

              <Col xs={6} sm={6} md={6} lg={4}>
                <Form.Item
                  name="nalco_rate"
                  label="Nalco Rate"
                  rules={[
                    { required: true, message: 'Please select rate per kg' },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="Fixed">Fixed</Radio>
                    <Radio value="Variable">Variable</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="workorder_type"
                  label="Work Order Type"
                  rules={[
                    { required: true, message: 'Please select work order type' },
                  ]}
                >
                  <Radio.Group>
                    <Radio value="In House">In House</Radio>
                    <Radio value="Job Work">Job Work</Radio>
                  </Radio.Group>
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} lg={12} xxl={12}>
                <Form.Item name="remarks" label="Remarks">
                  <Input.TextArea
                    placeholder="Enter remarks"
                    onChange={e => {
                      const value = e.target.value;

                      const formattedValue =
                        value.trim() === ''
                          ? null
                          : value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());

                      form.setFieldsValue({ remarks: formattedValue }); // Update Form state
                    }}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="purchase_order_copy"
                  label="Purchase Order Copy"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => {
                    if (Array.isArray(e)) {
                      return e;
                    }
                    return e?.fileList;
                  }}
                  rules={[
                    {
                      required: true,
                      message: 'Please upload purchase order copy file',
                    },
                    {
                      validator: (_, fileList) => {
                        if (!fileList || fileList.length === 0) return Promise.resolve();

                        const allowedExtensions = /\.(pdf|jpe?g|png)$/i;

                        for (let file of fileList) {
                          // Get filename from various possible sources
                          const fileName = file?.originFileObj?.name || file?.name || '';

                          if (!fileName || !allowedExtensions.test(fileName)) {
                            return Promise.reject(new Error("Only PDF, JPEG, JPG, or PNG files are allowed"));
                          }
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Upload
                    name="file"
                    listType="picture"
                    accept=".pdf,.jpeg,.jpg,.png"
                    maxCount={1}
                    beforeUpload={() => false}
                    showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }}
                    fileList={poCopyList}
                    onChange={handlePoCopyChange}
                    onRemove={handlePoCopyRemove}
                  >
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                  <label className="filenote">Upload PDF, JPEG, JPG or PNG file</label>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="work_order_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <Row
                      gutter={[24, 24]}
                      className="rowItem mx-0"
                      align="middle"
                      key={key}
                      wrap={false}
                      style={{ width: '100%' }}
                    >
                      <Col flex="auto">
                        <Row gutter={16} key={key}>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'die_profile']}
                              label="Profile Number"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select profile number',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Profile Number"
                                onChange={value => handleprofile(value, index)} // Pass the index here
                                labelInValue
                                loading={dieProfileLoading}
                                onPopupScroll={onScrollDieProfile}
                                notFoundContent={
                                  dieProfileLoading
                                    ? 'Loading...'
                                    : 'No options'
                                }
                                showSearch={true}
                                allowClear
                                onSearch={handleSearchDieProfile}
                                value={searchDieProfile}
                                filterOption={(input, option) =>
                                  option.children
                                    .toLowerCase()
                                    .includes(input.toLowerCase())
                                }
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    dieProfileList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option
                                    key={el.id}
                                    value={el.id}
                                    data-weight={el.wt_kg_p_mt}
                                  >
                                    {el.die_number}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              name={[name, 'customer_reference_number']}
                              label="Customer Reference No."
                            >
                              <Input placeholder="Enter Customer Ref. No" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'alloy']}
                              label="Alloy"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select alloy',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Alloy"
                                loading={alloyLoading}
                                onPopupScroll={onScrollAlloy}
                                notFoundContent={
                                  alloyLoading ? 'Loading...' : 'No options'
                                }
                                value={searchAlloy}
                                disabled
                                allowClear
                                showSearch={true}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    alloyList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option key={el.id} value={el.id}>
                                    {el.name} - {el.color_code}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'temper']}
                              label="Temper"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please select temper',
                                },
                              ]}
                            >
                              <Select
                                placeholder="Select Temper"
                                loading={temperLoading}
                                value={searchTemper}
                                onPopupScroll={onScrollTemper}
                                notFoundContent={
                                  temperLoading ? 'Loading...' : 'No options'
                                }
                                onChange={(value, option) =>
                                  handleTemer(value, option)
                                }
                                onSearch={handleSearchTemer}
                                allowClear
                                disabled
                                showSearch={true}
                                dropdownRender={menu => <>{menu}</>}
                              >
                                {[
                                  ...new Map(
                                    temperList.map(item => [item.id, item]),
                                  ).values(),
                                ].map((el, index) => (
                                  <Option key={el.id} value={el.id}>
                                    {el.name} - {el.code}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'length']}
                              label="Length(mm)"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter length',
                                },
                              ]}
                            >
                              <Input placeholder="0" disabled/>
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={3}>
                            <Form.Item
                              name={[name, 'pieces']}
                              label="Pieces"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter pieces',
                                },
                                {
                                  pattern: /^\d{1,6}$/,
                                  message:
                                    'Please enter a number with up to 6 digits',
                                },
                              ]}
                            >
                              <Input placeholder="0" />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'conversion']}
                              label="Conversion"
                              rules={[
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10, // Set max before decimal
                                  maxAfterDecimal: 3, // Set max after decimal
                                  allowDecimal: true,
                                  allowZero: true, // Allow 0 as a valid input
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" disabled/>
                            </Form.Item>
                          </Col>
                          <Col xs={12} sm={8} xl={2}>
                            <Form.Item
                              {...restField}
                              name={[name, 'packing_cost']}
                              label="Packing Cost"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter valid Conversion',
                                },
                              ]}
                            >
                              <Input placeholder="0.0" disabled />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'min_weight']}
                              label={`Net Weight - ${form.getFieldValue('tolerance')?.includes('-') ? form.getFieldValue('tolerance').match(/\d+/)?.[0] || '0' : '0'}%`}
                            >
                              <Input placeholder="0.0" disabled />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'net_weight']}
                              label="Net Weight (kg)"
                              rules={[
                                {
                                  pattern: /^\d{1,8}(\.\d{1,3})?$/,
                                  message:
                                    'Enter a valid number with up to 3 decimal places',
                                },
                              ]}
                            >
                              <Input
                                placeholder="0.0"

                              />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={3}>
                            <Form.Item
                              {...restField}
                              name={[name, 'max_weight']}
                              label={`Net Weight + ${form.getFieldValue('tolerance')?.includes('+') ? form.getFieldValue('tolerance').match(/\d+/)?.[0] || '0' : '0'}%`}
                            >
                              <Input placeholder="0.0" disabled />
                            </Form.Item>
                          </Col>
                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <label
                              className="customlabel flex"
                              style={{ marginBottom: '3px' }}
                            >
                              {' '}
                              Nalco -
                              <div className="ml-2">
                                <Checkbox
                                  disabled={
                                    form.getFieldValue([
                                      'work_order_details',
                                      name,
                                      'id',
                                    ]) && initialValues[name] === true // Use initial stored value
                                  }
                                  onChange={e => {
                                    const checked = e.target.checked;
                                    form.setFieldsValue({
                                      work_order_details: form
                                        .getFieldValue('work_order_details')
                                        .map((item, index) =>
                                          index === name
                                            ? {
                                              ...item,
                                              modify_nalco_rate: checked,
                                            }
                                            : item,
                                        ),
                                    });
                                  }}
                                >
                                  Edit Nalco Rate
                                </Checkbox>

                              </div>
                            </label>
                            <Form.Item
                              {...restField}
                              name={[name, 'nalco_rate']}
                              label=""
                              rules={[
                                createNumberValidationRule({
                                  allowNegative: false,
                                  maxBeforeDecimal: 10, // Set max before decimal
                                  maxAfterDecimal: 3, // Set max after decimal
                                  allowDecimal: true,
                                  allowZero: true,
                                }),
                              ]}
                            >
                              <Input placeholder="0.0" />
                            </Form.Item>

                          </Col>
                          {form.getFieldValue([
                            'work_order_details',
                            name,
                            'modify_nalco_rate',
                          ]) && (
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  name={[name, 'nalco_rate_change_reason']}
                                  label="Remarks"
                                  rules={[
                                    {
                                      required: true,
                                      message:
                                        'Remark is required when Nalco Rate is updated',
                                    },
                                  ]}
                                >
                                  <Input placeholder="Enter Remarks" />
                                </Form.Item>
                              </Col>
                            )}

                          <Col xs={12} md={8} xl={6} xxl={4}>
                            <Form.Item
                              {...restField}
                              name={[name, 'jobwork']}
                              label="Surface Finish"
                              rules={[{ required: true, message: 'Please select jobwork' }]}
                            >
                              <AutoOpenSelect
                                placeholder="Select Surface Finish"
                                mode="multiple"
                                value={form.getFieldValue([
                                  'sales_order_details',
                                  name,
                                  'surface_finish',
                                ])}
                                allowClear
                                disabled
                                showSearch
                                optionFilterProp="children"
                                onChange={value => {
                                  form.setFieldValue(
                                    ['sales_order_details', name, 'surface_finish'],
                                    value,
                                  );
                                }}
                                loading={jobWorkLoading}
                              >
                                {jobWorkLoading ? (
                                  <Option key="loading" disabled>
                                    Loading...
                                  </Option>
                                ) : (
                                  jobWorkdata.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))
                                )}
                              </AutoOpenSelect>
                            </Form.Item>
                          </Col>
                          <Form.Item
                            shouldUpdate={(prevValues, currentValues) =>
                              prevValues.work_order_details?.[index]?.surface_finish !==
                              currentValues.work_order_details?.[index]?.surface_finish
                            }
                            noStyle
                          >
                            {({ getFieldValue }) => {
                              const selectedSurfaceFinish = getFieldValue(["work_order_details", index, "surface_finish"]) || [];

                              const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));


                              // Example: show conditional field if Laser Marking selected
                              const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                              const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                              return (
                                <>
                                  {/* --- Engineering Fields --- */}
                                  {hasEngineering && (
                                    <>
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.work_order_details?.[index]?.cutting !== curr.work_order_details?.[index]?.cutting ||
                                          prev.work_order_details?.[index]?.machining !== curr.work_order_details?.[index]?.machining ||
                                          prev.work_order_details?.[index]?.deburring !== curr.work_order_details?.[index]?.deburring
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const cutting = getFieldValue(['work_order_details', index, 'cutting']);
                                          const machining = getFieldValue(['work_order_details', index, 'machining']);
                                          const deburring = getFieldValue(['work_order_details', index, 'deburring']);

                                          return (
                                            <>
                                              {cutting && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Cutting Price"
                                                    name={[name, 'cutting_price']}
                                                    rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                  >
                                                    <Input placeholder="0.0" disabled />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {machining && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Machining Price"
                                                    name={[name, 'machining_price']}
                                                    rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                  >
                                                    <Input placeholder="0.0" disabled />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {deburring && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Deburring Price"
                                                    name={[name, 'deburring_price']}
                                                    rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                  >
                                                    <Input placeholder="0.0" disabled />
                                                  </Form.Item>
                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                  {/* --- Surface Treatment Fields --- */}
                                  {hasSurfaceTreatment && (
                                    <>


                                      {/* Nested conditional price fields */}
                                      <Form.Item
                                        noStyle
                                        shouldUpdate={(prev, curr) =>
                                          prev.work_order_details?.[index]?.anodising !== curr.work_order_details?.[index]?.anodising ||
                                          prev.work_order_details?.[index]?.powder_coating !== curr.work_order_details?.[index]?.powder_coating ||
                                          prev.work_order_details?.[index]?.pvdf !== curr.work_order_details?.[index]?.pvdf
                                        }
                                      >
                                        {({ getFieldValue }) => {
                                          const anodising = getFieldValue(["work_order_details", index, "anodising"]);
                                          const powder_coating = getFieldValue(["work_order_details", index, "powder_coating"]);
                                          const pvdf = getFieldValue(["work_order_details", index, "pvdf"]);
                                          return (
                                            <>
                                              {anodising && (
                                                <Col xs={12} md={8} xl={3}>
                                                  <Form.Item
                                                    label="Anodising Price"
                                                    name={[name, "anodising_price"]}
                                                    rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                  >
                                                    <Input placeholder="Enter Anodising Price" />
                                                  </Form.Item>
                                                </Col>
                                              )}

                                              {powder_coating && (
                                                <>
                                                  <Col xs={12} md={8} xl={4}>
                                                    <Form.Item
                                                      label="Powder Coating Description"
                                                      name={[name, "powder_coating_description"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Description" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Description" disabled />
                                                    </Form.Item>
                                                  </Col>
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Powder Coating Price"
                                                      name={[name, "powder_coating_price"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Price" disabled/>
                                                    </Form.Item>
                                                  </Col>
                                                </>
                                              )}

                                              {pvdf && (
                                                <Col xs={12} md={8} xl={3}>

                                                  <Form.Item
                                                    label="PVDF Price"
                                                    name={[name, "pvdf_price"]}
                                                    rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                  >
                                                    <Input placeholder="Enter PVDF Price" />
                                                  </Form.Item>

                                                </Col>
                                              )}
                                            </>
                                          );
                                        }}
                                      </Form.Item>
                                    </>
                                  )}
                                </>
                              );
                            }}
                          </Form.Item>
                        </Row>
                      </Col>
                      <Col>
                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '30px',
                              }}
                            />
                          )}
                        </div>
                      </Col>
                    </Row>
                  ))}
                  {/* <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 15) {
                            add({ nalco_rate: pricePerKg });
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item> */}
                </>
              )}
            </Form.List>
          </div>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
              loading={btnLoading}
            >
              Convert Sales Order To Work Order
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default ConvertSalesToWorkOrder;
